import { HttpResponse } from '@angular/common/http';

import { PlaceBetResponse } from '@frontend/sports/types/betslip';

import { SignedName } from '../../core/picks/signed-name.model';
import { QueryPlaceStatusPayload } from '../betplacement/actions';
import { IPlacedBetslipResult } from '../betplacement/models';
import { ITeaserBetPickState } from './state';

export interface BetslipTeaserInfo {
    picks: Record<string, ITeaserBetPickState>;
    sportId: number;
    stake: number | null;
    headerTitle?: SignedName;
    enabled: boolean;
    placeBlocking: boolean;
}

export interface TeaserBetKeypoint {
    value: number;
    active: boolean;
    disabled: boolean;
}

export interface BetslipTeaserTrackingData {
    action?: string;
    position?: number;
    sportId?: number;
    leagueId?: string;
    eventDetails?: string;
    positionEvent?: string;
    isLinear?: boolean;
}

export interface BetslipTeaserPickPointsTrackingData {
    index: number;
    eventDetails: string;
    isSelected: boolean;
}

export enum BetslipTeaserTrackingConstants {
    CategoryEvent = 'betslip',
    LabelEvent = 'full betslip',
    PositionEvent = 'teaser bets',
    SourceTabbed = 'tabbed betslip',
    SourceLinear = 'linear betslip',
    EventDetails = 'teaser points',
    TeaserBet = 'teaser bet',
    Checked = 'checked',
    Unchecked = 'unchecked',
    LocationEvent = 'slider',
}

export enum TrackingEvent {
    Click = 'Click',
    Load = 'Load',
    Checked = 'Checked',
    UnChecked = 'UnChecked',
}

export enum AddPickPayloadType {
    Sport,
    Race,
    RaceFreeForm,
    BetBuilder,
}

export interface IAddSportPickPayload {
    pickId: string;
    fixtureId: string;
    optionId: number;
}

export interface IBetslipTeaserErrorState {
    placeBlocking: boolean;
    oddsChanged: boolean;
    oddsAccepted: boolean;
    lockedPicksCount: number;
    hasLivePicks: boolean;
    hasComboPrevention: boolean;
    picksErrorNumber: number;
    isStakeEmpty: boolean;
    hasPickWithoutPrice: boolean;
    hasRewardError: boolean;
}

export interface IBetslipTeasersErrorState {
    teaserErrorStates: { [sportId: number]: IBetslipTeaserErrorState };
    errorState: IBetslipTeaserErrorState;
}

export interface IFinishPlaceTeaserBets {
    results: { context: QueryPlaceStatusPayload; placedBetslipResult: IPlacedBetslipResult }[];
}

export interface IPlaceBetResult {
    context: QueryPlaceStatusPayload;
    response: HttpResponse<PlaceBetResponse>;
}

export interface IPlaceBetPendingResult {
    context: QueryPlaceStatusPayload;
    pendingResult: { delay: number };
}

export interface IPlaceBetDoneResult {
    context: QueryPlaceStatusPayload;
    placedBetslipResult: IPlacedBetslipResult;
}

export interface ITeaserBetsResponsePayload {
    [guid: string]: IPlaceBetResult;
}

export const LinearTeaserExpandedLocalStorageKey = 'linearTeaserExpanded';

export enum LinearTeaserBetTracking {
    TeaserBetPositionEvent = 'Teaser bet expand/collapse',
    HidePickListEventDetails = 'Collapse teaser bet',
    ViewPickListEventDetails = 'Expand teaser bet',
    TeaserBetPosition = 'teaser bets',
}
